import { autobind } from 'core-decorators'

class NumberInput {
  constructor(element) {
    this.element = element
    this.inc = this.$element.find('.inc');
    this.dec = this.$element.find('.dec');
    this.input = this.$element.find('input');

    this.min = this.input.attr('min');
    this.max = this.input.attr('max');
    this.step = this.input.attr('step') || 1;

    this.inc.on('click', this.increase);
    this.dec.on('click', this.decrease);
    this.input.on('change', this.checkValue);
    $(this.element).addClass('initialized');
  }

  get $element() {
    return $(this.element);
  }

  get minValue() {
    return parseInt(this.min);
  }

  get stepValue() {
    return parseInt(this.step);
  }

  get maxValue() {
    return parseInt(this.max);
  }

  static create(element) {
    return new NumberInput(element);
  }

  @autobind
  increase(e) {
    e.preventDefault();
    let value = parseInt(this.input.val());
    let newValue = value + this.stepValue;
    if (this.max && this.maxValue < newValue) {
      newValue = this.maxValue;
    }
    this.input.val(newValue);
  }

  @autobind
  decrease(e) {
    e.preventDefault();
    let value = parseInt(this.input.val());
    let newValue = value - this.step;
    if (this.min && newValue < this.minValue) {
      newValue = this.minValue
    }
    this.input.val(newValue);
  }

  @autobind
  checkValue() {
    let value = parseInt(this.input.val());
    if (this.min && value < this.minValue) {
      this.input.val(this.minValue);
    }
    if (this.max && value > this.maxValue) {
      this.input.val(this.maxValue);
    }


    // if (this.input.val() < this.min) {
    //   this.input.val(0);
    // }
  }
}


$('.number-input:not(.initialized)').each((index, input) => {
  NumberInput.create(input);
});

$(window).on('contentchanged', function() {
  $('.number-input:not(.initialized)').each((index, input) => {
    NumberInput.create(input);
  });
});



// WEBPACK FOOTER //
// ./src/js/components/number-input.js